import { Outlet } from 'react-router';

import { EmailVerificationBanner } from './email-verification-banner';
import { Header } from './header';
import { ShellSlotProvider } from './shell-slots';

import { EulaGate, LegalFooter } from '@/legal';

/**
 * Application shell: viewport-locked, no document scrolling.
 *
 * The middle grid row (`minmax(0,1fr)` + `overflow-hidden`) hands each
 * page a bounded box — scrolling only happens in regions a page
 * explicitly declares via the Page/PageBody primitives (page.tsx).
 * `h-dvh` (not `h-screen`) so the shell tracks dynamic browser chrome
 * on tablets and scaled displays.
 *
 * It also carries the EULA overlay, which is why every page below it is gated
 * and the onboarding funnel — which renders its own full-page shell instead of
 * this one — is not. See `GATING_CHAIN` in `router/index.tsx`.
 *
 * The unverified email banner (ESCLOUD-333) sits at the top of the grid,
 * ahead of `Header`: it renders `null` when the claim is anything but a
 * proven `unverified`, so its `auto` row collapses and costs nothing on
 * every other page.
 */
export function RootLayout() {
    return (
        <ShellSlotProvider>
            {/* Blocking overlay, not a route element: it renders beside the page,
                so the page below stays rendered while the gate query resolves. */}
            <EulaGate />
            <div className="grid h-dvh grid-rows-[auto_auto_minmax(0,1fr)_auto]">
                <EmailVerificationBanner />
                <Header />
                <main className="relative overflow-hidden bg-grid">
                    <Outlet />
                </main>
                <LegalFooter />
            </div>
        </ShellSlotProvider>
    );
}
